const AUTH_ORIGIN = "https://auth.blazeboard.co";

export function signInUrl(redirectTo: string): string {
  return authUrl("/login", redirectTo);
}

export function signUpUrl(redirectTo: string): string {
  return authUrl("/signup", redirectTo);
}

function authUrl(path: "/login" | "/signup", redirectTo: string): string {
  const url = new URL(path, AUTH_ORIGIN);
  url.searchParams.set("redirect", redirectTo);
  return url.toString();
}
